import { fromJS } from "immutable";
import * as types from "../constants";

const defaultState = fromJS({
  chargeName: "",
  chargePrice: 0,
  chargeStatus: "active",
  countAll: 0,
  countUsed: 0,
  countViewFree: 0,
  firstInstallAt: "2022-04-05T10:00:00Z",
  applyChargeDiscount: false,
  applyChargeVersion: 0,
  planLoading: false,
  appDisableFreePlan: false,
});

let data;

const pricingReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.GET_DATA_PLAN:
      return state.set("planLoading", true);
    case types.GET_DATA_PLAN_RESULT:
      data = action.payload;
      return state
        .set("planLoading", false)
        .set("appDisableFreePlan", data.app_disable_free_plan)
        .set("applyChargeDiscount", data.apply_charge_discount)
        .set("applyChargeVersion", data.apply_charge_version)
        .set("chargeName", data.charge_name)
        .set("chargePrice", data.charge_price)
        .set("chargeStatus", data.charge_status)
        .set("countAll", data.count_all)
        .set("countUsed", data.count_used)
        .set("firstInstallAt", data.first_install_at)
        .set("countViewFree", data.count_view_free);
    default:
      return state;
  }
};

export default pricingReducer;
